import Countable from 'countable';

export class CharCount {
    /**
     * @type {HTMLElement}
     */
    target = null;

    /**
     * @type {HTMLDivElement|null}
     */
    countDisplay = null;

    /**
     * @type {number}
     */
    limit = 100;

    /**
     * @type {number}
     */
    lowThreshold = 10;

    /**
     * @type {HTMLElement|null}
     */
    wrapper = null;

    /**
     * @param {HTMLElement} target
     */
    constructor(target) {
        this.target = target;
        this.limit = target.getAttribute('data-cc-limit')
            ? parseInt(target.getAttribute('data-cc-limit'), 10)
            : 100;
        this.lowThreshold = target.getAttribute('data-cc-low')
            ? parseInt(target.getAttribute('data-cc-low'), 10)
            : 10;

        // Berechne den aktuellen Zeichenstand beim Initialisieren
        const initialCount = this.target.value.length;

        // Suche den Wrapper für CSS-Klassen
        this.wrapper = this.target.closest('.powermail_fieldwrap, .form-field, .csc-form-element-textarea');

        // Erstelle das Anzeige-Element für verbleibende Zeichen
        this.countDisplay = document.createElement('div');
        this.countDisplay.className = 'chars-remaining';
        this.countDisplay.innerHTML = `<span>${initialCount} / ${this.limit}</span>`;
        this.target.insertAdjacentElement('afterend', this.countDisplay);

        // Maximal erlaubte Zeichen setzen
        this.target.setAttribute('maxlength', this.limit);

        // Event-Listener setzen
        this.initCountable();
    }

    /**
     * Initialisiert Countable.js
     */
    initCountable() {
        Countable.on(this.target, (counter) => {
            let currentCount = counter.all;
            let remaining = this.limit - currentCount;

            if (remaining < 0) {
                currentCount = this.limit;
                this.target.value = this.target.value.substring(0, this.limit);
            }

            this.countDisplay.innerHTML = `<span>${currentCount} / ${this.limit}</span>`;

            // CSS-Klassen für Fehler und Warnungen
            if (remaining === 0) {
                this.wrapper?.classList.add('error');
            } else if (remaining <= this.lowThreshold) {
                this.wrapper?.classList.add('count-low');
                this.wrapper?.classList.remove('error');
            } else {
                this.wrapper?.classList.remove('count-low', 'error');
            }
        });
    }
}
